import { render, staticRenderFns } from "./OrderDetailTransferView.vue?vue&type=template&id=7611301a&scoped=true"
import script from "./OrderDetailTransferView.vue?vue&type=script&lang=js"
export * from "./OrderDetailTransferView.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailTransferView.vue?vue&type=style&index=0&id=7611301a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7611301a",
  null
  
)

export default component.exports